export default {
  AD_PRODUCTS: "adProducts",
  CONTENT_TAG: "contentTag",
  CONTENT_TAG_LIST: "contentTagList",
  VIDEO_DETAILS: "videoDetails",
  CONTENT_TAG_PRINTABLE_LIST: "contentTagPrintableList",
  CONTENT_TAG_VIDEO_LIST: "contentTagVideoList",
  CONTENT_TAG_BLOG_LIST: "contentTagBlogList",
  PRINTABLE_DETAILS: "printableDetails",
  CHAMPIVERSE_VIDEOS: "champiverseVideos",
  RECENTLY_PUBLISHED_VIDEOS: "recentlyPublishedVideos",
  HERO_VIDEO: "heroVideo",
  NEWEST_PRINTABLES: "newestPrintables",
  USER: "user",
  HOME_SPOTLIGHT: "homeSpotlight",
  FEATURED_CONTENT: "featuredContent",
  SEARCH: "search",
  AD_PRODUCT_PRE_ROLL_SLATE: "adProductPreRollSlate",
  SHELVES: "shelf",
  GRADES: "grades",
  SCHOOLS: "schools",
  EMAIL_VALIDATION: "emailValidation",
};
